import React from "react"

import DisclosureHeader from "./DisclosuresHeader"
import FormContainer from "../../components/FormContainer"
import Layout from "../../components/AuthenticatedLayout"
import DisclosureForm from "../../forms/UpdateDisclosure"

export default function UpdateDisclosure() {
  return (
    <Layout title="Sale Disclosures">
      <DisclosureHeader />
      <FormContainer fullWidth wideContent>
        <DisclosureForm />
      </FormContainer>
    </Layout>
  )
}
